import React, { useState } from 'react'
import PotentialLabel from '../PotentialLabel/PotentialLabel'
import { usePotential } from '../PotentialContext/PotentialContext'
import { handleDollarValueLabelChange, removeLeadingZeros } from '../utils/helpers';
import { isValidDecimalInput } from '../../../helper/helpers';
import PotentialInput from '../PotentialInput/PotentialInput';

const Contributions = ({value}) => {
    const { updateUserInfo } = usePotential();
    const [contribution, setContribution] = useState(value)

    const  handleOnChange = (e) => {
        let value = e.target.value;
        value = removeLeadingZeros(value);
        const isValidDecimal = isValidDecimalInput(value);
        if(!isValidDecimal) return;

        setContribution(value);

        const contributionItem = parseFloat(value);
        updateUserInfo({ contributionItem })
    }

    return (
        <PotentialLabel
            label={"Annualized Contributions"} 
            value={handleDollarValueLabelChange(contribution)}
            infoText={"This is the annualized ammount you decided to contribute to this account"}
        >
            <PotentialInput value={contribution} handleOnChange={handleOnChange} />
        </PotentialLabel>
    )
}

export default Contributions